import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';

import { AccessoryDtoSchema } from '../schemas/AccessoryDto';
import { SaveAccessoryRequestModelSchema } from '../schemas/SaveAccessoryRequestModel';

export const PathParametersSchema = z.object({
	Id: z.string(),
});
export type PathParameters = z.infer<typeof PathParametersSchema>;

// No QueryParameters

export const RequestBodySchema = z.lazy(() => SaveAccessoryRequestModelSchema);
export type RequestBody = z.infer<typeof RequestBodySchema>;

const ResponseDataSchema = z.lazy(() => AccessoryDtoSchema);
export type ResponseData = z.infer<typeof ResponseDataSchema>;
const validator = createValidator(ResponseDataSchema);

export async function callApi(input: {
	pathParameters: PathParameters;
	requestBody: RequestBody;
}): Promise<Optional<ResponseData>> {
	const url: string = SERVICEBASEURL.BACKEND + `/Accessory/${input.pathParameters.Id}`;
	return (await axios.put(url, input.requestBody).toOptionalFiltered(validator)).map(
		(x) => x.data
	);
}
